import { Form, Space } from "antd";
import PrefillInfoAlert from "./components/PrefillInfoAlert";
import QuizDetailsForm from "./components/QuizDetailsForm";
import QuizDetailsFooter from "./components/QuizDetailsFooter";
import { useQuizContext } from "Pages/MySchedule/MyScheduledBeta/quiz/context/QuizContext";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { useContext, useEffect } from "react";
import { UserInfoContext } from "Context/CommonContext";
import { LOD1, QuestionType } from "utilFunctions/Constants/Constants";
import Typography from "Components/CommonComponents/Typography";

const QuizDetailsPage = ({ setSelectedCourse }: any) => {
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const subjectsListing: any[] = userInfo?.subjectsListing || [];
  const userStreams: any[] = userInfo.userStreams || [];
  const [form] = Form.useForm();
  const { setStepperForm, editableQuiz } = useQuizContext();
  const courseChanged = Form.useWatch("courseId", form);
  useEffect(() => {
    if (courseChanged) {
      setSelectedCourse(courseChanged);
    }
  }, [courseChanged]);
  useEffect(() => {
    form.setFieldsValue(editableQuiz);
  }, [editableQuiz]);
  return (
    <Form
      form={form}
      layout="vertical"
      disabled={editableQuiz.id ? true : false}
      onFinish={(values: any) => {
        setStepperForm((prevForm: any) => ({
          ...prevForm,
          step1: values,
        }));
      }}
      // onValuesChange={() => {
      //   setSelectedQuestions([]);
      //   setQuestions([]);
      // }}
      initialValues={{
        streamId: userStreams.length > 1 ? userStreams[0]?.value : null,
        subjectId:
          subjectsListing.length > 1 ? subjectsListing[0]?.value : null,
        questionType: QuestionType[0]?.value,
        lod1: LOD1[0]?.value,
      }}
    >
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        <div>
          <Typography color="black" variant="h5">
            Quiz Details
          </Typography>
        </div>
        <PrefillInfoAlert />
        <QuizDetailsForm form={form} />
        <QuizDetailsFooter form={form} />
      </Space>
    </Form>
  );
};

export default QuizDetailsPage;
